import { shouldForwardPrimitiveProp as e } from "./primitiveProps.mjs";
import { Box as t } from "./Box.mjs";
import { clampFrTracks as n } from "./gridTracks.mjs";
import { styled as r } from "styled-components";
//#region src/components/Primitives/Grid.tsx
var i = (e) => {
	if (e !== void 0) return n(typeof e == "number" ? `repeat(${e}, 1fr)` : e);
}, a = (e) => {
	if (e !== void 0) return typeof e == "number" ? `repeat(${e}, auto)` : e;
}, o = r(t).withConfig({ shouldForwardProp: e })`
    display: ${({ inline: e }) => e ? "inline-grid" : "grid"};
    ${({ columns: e }) => i(e) ? `grid-template-columns: ${i(e)};` : ""}
    ${({ rows: e }) => a(e) ? `grid-template-rows: ${a(e)};` : ""}
    ${({ areas: e }) => e ? `grid-template-areas: ${e};` : ""}
    ${({ theme: e, gap: t }) => t === void 0 ? "" : `gap: ${typeof t == "number" ? e.spacing(t) : t};`}
    ${({ theme: e, columnGap: t }) => t === void 0 ? "" : `column-gap: ${typeof t == "number" ? e.spacing(t) : t};`}
    ${({ theme: e, rowGap: t }) => t === void 0 ? "" : `row-gap: ${typeof t == "number" ? e.spacing(t) : t};`}
    ${({ align: e }) => e ? `align-items: ${e};` : ""}
    ${({ justify: e }) => e ? `justify-items: ${e};` : ""}
    ${({ responsive: e }) => e && Object.entries(e).map(([e, t]) => `
            @media (max-width: ${e}px) {
                ${t.columns === void 0 ? "" : `grid-template-columns: ${i(t.columns)};`}
            }
        `).join("")}
`;
o.displayName = "Grid";
var s = r(t).withConfig({ shouldForwardProp: e })`
    ${({ area: e }) => e ? `grid-area: ${e};` : ""}
    ${({ colSpan: e }) => e ? `grid-column: span ${e};` : ""}
    ${({ rowSpan: e }) => e ? `grid-row: span ${e};` : ""}
    ${({ colStart: e }) => e ? `grid-column-start: ${e};` : ""}
    ${({ rowStart: e }) => e ? `grid-row-start: ${e};` : ""}
    ${({ order: e }) => e === void 0 ? "" : `order: ${e};`}
    ${({ responsive: e }) => e && Object.entries(e).map(([e, t]) => `
            @media (max-width: ${e}px) {
                ${t.colStart === void 0 ? "" : `grid-column-start: ${t.colStart};`}
                ${t.colSpan === void 0 ? "" : `grid-column: span ${t.colSpan};`}
                ${t.rowStart === void 0 ? "" : `grid-row-start: ${t.rowStart};`}
                ${t.rowSpan === void 0 ? "" : `grid-row: span ${t.rowSpan};`}
                ${t.order === void 0 ? "" : `order: ${t.order};`}
                ${t.area === void 0 ? "" : `grid-area: ${t.area};`}
            }
        `).join("")}
`;
s.displayName = "GridItem";
var c = r(t).withConfig({ shouldForwardProp: e })`
    display: flex;
    flex-direction: column;
    ${({ theme: e, gap: t }) => t === void 0 ? "" : `gap: ${typeof t == "number" ? e.spacing(t) : t};`}
    ${({ dissolveBelow: e }) => e === void 0 ? "" : `
        @media (max-width: ${e}px) {
            display: contents;
        }
    `}
`;
c.displayName = "GridColumn";
//#endregion
export { o as Grid, c as GridColumn, s as GridItem };
